import React from 'react'

import Dialog, { DialogProps } from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog-header'

import CreateCustomFieldsForm from './form/create-custom-fields-form'

type Props = DialogProps & {
  onClose: () => void
}

const CreateCustomFieldsDialog: React.FC<Props> = (props) => (
  <Dialog {...props}>
    <DialogHeader title="Add custom fields" onClose={props.onClose} />
    <CreateCustomFieldsForm onExit={props.onClose} />
  </Dialog>
)

export default CreateCustomFieldsDialog
